import projection from '../generated/pwg5m5f1.json';
import { AcceptanceManifest } from '../types';

export const pwg5m5f1AcceptanceManifest = projection as AcceptanceManifest;
